import React from 'react';
import { Iso } from '@material-ui/icons';
import FormConfigLayoutGrid from '../../config/FormConfigLayoutGrid';
import FormConfigRadioGroup from '../../config/FormConfigRadioGroup';
import { FormRadioGroup } from '../../fields/FormRadioGroup';
export const FormYesNoPlugin = {
    icon: React.createElement(Iso, null),
    name: 'Yes/No (True/False)',
    type: 'Boolean',
    dataTypes: ['boolean'],
    configurator: FormConfigRadioGroup,
    layoutConfigurator: () => React.createElement(FormConfigLayoutGrid, null),
    element: FormRadioGroup
};
//# sourceMappingURL=FormYesNoPlugin.js.map